import { theme as sharedTheme } from '@bottlebooks/gatsby-shared';
import { theme as baseTheme } from '@bottlebooks/gatsby-theme-base';
import filter from '../components/Filters/filterFieldVariants';
import quickLink from '../components/LandingPage/quickLinkVariants';

const theme = {
  ...baseTheme,
  ...sharedTheme,

  // # Component variants
  filter,
  quickLink,
};

export default theme;
